.datePickerInput {
  --ixf-date-picker-input-border-weight: 1px;
  --ixf-input-padding: calc(var(--ixf-input-padding-vertical) + var(--ixf-input-label-active-offset)) var(--ixf-input-padding-horizontal) calc(var(--ixf-input-padding-vertical) - var(--ixf-input-label-gap)) var(--ixf-input-padding-horizontal);

  overflow: visible;

  .fieldContainer {
    position: relative;
  }

  .rangeInputElement {
    border-radius: var(--ixf-input-border-radius);
  }

  .rangeContainer {
    .fieldContainer {
      border-radius: var(--ixf-input-border-radius);
      border-top: var(--ixf-input-border-weight) solid var(--ixf-input-border-color);
      border-left: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
      border-right: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
      border-bottom: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
    }
  }

  .inputElement {
    &:not(.rangeContainer) {
      border-left: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
      border-right: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
    }

    &:not(.rangeContainer):first-of-type {
      border-top: var(--ixf-input-border-weight) solid var(--ixf-input-border-color);
      border-top-left-radius: var(--ixf-input-border-radius);
      border-top-right-radius: var(--ixf-input-border-radius);
    }

    &:not(.rangeContainer):last-of-type {
      border-bottom: var(--ixf-date-picker-input-border-weight) solid var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);
    }
  }

  .affix {
    flex: 0 0 auto;

    button {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        cursor: default;
      }
    }
  }

  .prefix {
    padding-left: var(--ixf-input-padding-horizontal);
  }

  .suffix {
    padding-right: var(--ixf-input-padding-horizontal);

    .clearButton {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }
    }
  }
}
